import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  padding: 16px;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 24px;
  width: 100%;
  max-width: 360px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
  padding: 20px;
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
  border-radius: 24px 24px 0 0;
  
  h3 {
    margin: 0;
    color: white;
    font-size: 16px;
    font-weight: 700;
  }
  
  p {
    margin: 6px 0 0 0;
    color: rgba(255, 255, 255, 0.8);
    font-size: 13px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const FacesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
`;

export const FaceButton = styled.button<{ selected: boolean; disabled?: boolean }>`
  width: 60px;
  height: 60px;
  border-radius: 14px;
  border: 2px solid ${props => props.selected ? '#7c3aed' : '#e2e8f0'};
  background: ${props => props.selected ? 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)' : 'white'};
  color: ${props => props.selected ? '#7c3aed' : '#475569'};
  font-size: 14px;
  font-weight: 700;
  cursor: ${props => props.disabled && !props.selected ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled && !props.selected ? 0.4 : 1};
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  
  &:hover:not(:disabled) {
    border-color: #7c3aed;
  }
  
  small {
    font-size: 9px;
    font-weight: 500;
    color: ${props => props.selected ? '#7c3aed' : '#94a3b8'};
  }
`;

export const InfoText = styled.p`
  margin: 0;
  font-size: 13px;
  color: #64748b;
  text-align: center;
`;

export const SelectedList = styled.div`
  padding: 8px 16px;
  background: #f8fafc;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #7c3aed;
  text-align: center;
  min-width: 120px;
`;

export const ModalFooter = styled.div`
  display: flex;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid #e2e8f0;
`;

export const FooterButton = styled.button<{ variant?: 'primary' | 'secondary' }>`
  flex: 1;
  padding: 14px 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  ${props => props.variant === 'primary' ? `
    background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
    border: none;
    color: white;
    
    &:disabled {
      background: #94a3b8;
    }
  ` : `
    background: white;
    border: 2px solid #e2e8f0;
    color: #475569;
    
    &:hover {
      border-color: #7c3aed;
      color: #7c3aed;
    }
  `}
`;
